export * from "@vaadin/details/vaadin-details.js";
export * from './generated/Details.js';
